import React from "react";

export default function Header() {
  return (
    <div className="booking-header">
      <div className="booking-header-bg"></div>
      <div className="booking-header-content mt-5">
        <div>
          <h3 className="booking-header-title">Booking Lapangan</h3>
          <p className="booking-header-text">
            Booking lapangan anda dengan cepat dan mudah di sini
          </p>
        </div>
      </div>
    </div>
  );
}
